import { createSelector } from '@reduxjs/toolkit';
import {
    multiTariffAdvancedTariffListMobile,
    multiTariffBasicTariffListMobile,
    multiTariffFamilyTariffListMobile,
} from 'reactApp/appHelpers/featuresHelpers/features/multiTariffMobile';
import {
    priceDiffAdvancedTariffListMobile,
    priceDiffBasicTariffListMobile,
    priceDiffFamilyTariffListMobile,
} from 'reactApp/appHelpers/featuresHelpers/features/priceDifferentiation';
import { ProductsSelectors } from 'reactApp/modules/products/products.selectors';
import { getMultiTariffMobileActiveTab } from 'reactApp/modules/quotaLanding/quotaLanding.selector';
import type { RootState } from 'reactApp/store';
import type { Product } from 'reactApp/types/Billing';
import { ETabsName } from 'reactApp/ui/TariffSectionNew/TariffSection.constants';

export const getMultiTariffMobileProductsSpacesListByTab = createSelector(
    [
        (state: RootState) =>
            ProductsSelectors.getNormalizedProductsBySpace(state, [
                ...multiTariffBasicTariffListMobile.year,
                ...multiTariffBasicTariffListMobile.month,
            ]),
        (state: RootState) =>
            ProductsSelectors.getNormalizedProductsBySpace(state, [
                ...multiTariffAdvancedTariffListMobile.year,
                ...multiTariffAdvancedTariffListMobile.month,
            ]),
        (state: RootState) =>
            ProductsSelectors.getNormalizedProductsBySpace(state, [
                ...multiTariffFamilyTariffListMobile.year,
                ...multiTariffFamilyTariffListMobile.month,
            ]),
        (state: RootState) => getMultiTariffMobileActiveTab(state),
    ],
    (basicTariffs, advancedTariffs, familyTariffs, activeTab) => {
        let products: Record<number, { yearProduct: undefined | Product; monthProduct: undefined | Product }> = {};
        let yearProductIDs: string[] = [];

        if (activeTab === ETabsName.basic) {
            products = basicTariffs;
            yearProductIDs = multiTariffBasicTariffListMobile.year;
        } else if (activeTab === ETabsName.advanced) {
            products = advancedTariffs;
            yearProductIDs = multiTariffAdvancedTariffListMobile.year;
        } else if (activeTab === ETabsName.family) {
            products = familyTariffs;
            yearProductIDs = multiTariffFamilyTariffListMobile.year;
        }

        const spaces = Object.values(products)
            .sort((a, b) => {
                if (a.yearProduct && b.yearProduct) {
                    return yearProductIDs.indexOf(a.yearProduct.id) - yearProductIDs.indexOf(b.yearProduct.id);
                }
                return 0;
            })
            .map((item) => item.yearProduct?.space.original || 0)
            .filter(Boolean);

        return { products, spaces, selectorDataLoaded: true };
    }
);

// tempexp_19499-start
export const getMultiTariffMobilePriceDiff = createSelector(
    [
        (state: RootState) =>
            ProductsSelectors.getNormalizedProductsBySpace(state, [
                ...priceDiffBasicTariffListMobile.year,
                ...priceDiffBasicTariffListMobile.month,
            ]),
        (state: RootState) =>
            ProductsSelectors.getNormalizedProductsBySpace(state, [
                ...priceDiffAdvancedTariffListMobile.year,
                ...priceDiffAdvancedTariffListMobile.month,
            ]),
        (state: RootState) =>
            ProductsSelectors.getNormalizedProductsBySpace(state, [
                ...priceDiffFamilyTariffListMobile.year,
                ...priceDiffFamilyTariffListMobile.month,
            ]),
        (state: RootState) => getMultiTariffMobileActiveTab(state),
    ],
    (basicTariffs, advancedTariffs, familyTariffs, activeTab) => {
        let products: Record<number, { yearProduct: undefined | Product; monthProduct: undefined | Product }> = {};
        let yearProductIDs: string[] = [];

        if (activeTab === ETabsName.basic) {
            products = basicTariffs;
            yearProductIDs = priceDiffBasicTariffListMobile.year;
        } else if (activeTab === ETabsName.advanced) {
            products = advancedTariffs;
            yearProductIDs = priceDiffAdvancedTariffListMobile.year;
        } else if (activeTab === ETabsName.family) {
            products = familyTariffs;
            yearProductIDs = priceDiffFamilyTariffListMobile.year;
        }

        const spaces = Object.values(products)
            .sort((a, b) => {
                if (a.yearProduct && b.yearProduct) {
                    return yearProductIDs.indexOf(a.yearProduct.id) - yearProductIDs.indexOf(b.yearProduct.id);
                }
                return 0;
            })
            .map((item) => item.yearProduct?.space.original || 0)
            .filter(Boolean);

        return { products, spaces, selectorDataLoaded: true };
    }
);
// tempexp_19499-end
